// JsFromRoutes CacheKey 407ede799e92b0c47a8bef14018abc43
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  get: definePathHelper('get', '/drive/export'),
  create: definePathHelper('post', '/drive/export'),
}
